<div #modalRef id="modalImagen" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">

            <div class="modal-header">
                <h5 class="modal-title">Vista previa</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    (click)="cerrarModal()"></button>
            </div>

            <div class="modal-body text-center">
                <img [src]="imagenSrc" alt="Vista previa" class="img-fluid rounded shadow" *ngIf="imagenSrc">
            </div>

            <div class="modal-footer justify-content-center">

            </div>
        </div>
    </div>
</div>